import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";

const benefits = [
  "We pay all closing costs",
  "Zero commissions or agent fees",
  "No cleaning or repairs needed — sell as-is",
  "Close in as little as 7 days",
  "Skip the endless showings and open houses",
  "A fair, honest offer with no obligation",
];

export const Benefits = () => (
  <section
    id="benefits"
    data-testid="benefits-section"
    className="bg-stone-50 py-20 md:py-32 px-6 md:px-12 lg:px-16"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative"
      >
        <img
          src="https://images.unsplash.com/photo-1781229771042-2a859f8f8022?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxoYW5kc2hha2UlMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc4MzA0ODY1Mnww&ixlib=rb-4.1.0&q=85&w=1200"
          alt="Handshake over a home purchase"
          className="rounded-2xl shadow-xl w-full h-[420px] object-cover"
          data-testid="benefits-image"
        />
        <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-lg p-6 border border-stone-100 hidden sm:block">
          <p className="font-heading text-3xl font-bold text-emerald-600">7 Days</p>
          <p className="text-sm text-slate-500 mt-1">Average closing time</p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="uppercase text-xs md:text-sm tracking-[0.2em] font-semibold text-emerald-700">
          The Better Way To Sell
        </span>
        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Why Sell To Us vs. a Traditional Agent
        </h2>
        <p className="mt-4 text-base md:text-lg text-slate-600">
          No repairs, no fees, no waiting months for a buyer. We handle everything so you can move on with peace of mind.
        </p>
        <ul className="mt-8 space-y-4">
          {benefits.map((b, i) => (
            <li key={i} data-testid={`benefit-item-${i + 1}`} className="flex items-start gap-3">
              <CheckCircle weight="fill" className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-0.5" />
              <span className="text-slate-700 text-lg">{b}</span>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);
